// Métadonnées du composant buttonModule
import type { ComponentMetadata } from '../../G&CSCM/Core/types';

export interface ButtonModuleParams {
    label: string;
    text?: string;
}

export const ButtonModuleConfig: ComponentMetadata = {
    name: 'buttonModule',
    displayName: 'Button Module',
    description: 'Module de démonstration avec bouton',
    category: 'UI',
    defaultParams: {
        label: 'Demo',
        text: ''
    },
    paramDefinitions: {
        label: {
            type: 'string',
            label: 'Label',
            description: 'Texte du label',
            editable_by_dev: true,
            editable_by_user: true  // Les utilisateurs peuvent modifier le label
        },
        text: {
            type: 'string',
            label: 'Texte',
            description: 'Texte supplémentaire',
            editable_by_dev: true,
            editable_by_user: true  // Les utilisateurs peuvent modifier le texte
        }
    },
    outsideGrid: false,
    defaultEnabled: true
};

export default ButtonModuleConfig;

